import { durationFormatFilterModule } from '../../../../../shared/app/filters/duration-format';
import { invitationsServiceModule } from '../../../../../shared/app/services/invitations-service/invitations-service';
import { accountServiceModule } from '../../../../../shared/app/services/account-service/account-service';
import { registerAccountComponentModule } from '../../../components/register-account/register-account';
import { legalLinksComponentModule } from '../../../../../shared/app/components/legal-links/legal-links';
import webcamRestartTemplate from '../../../components/webcam-start/webcam-restart.tpl.html';
import { CAMERA_WARMUP_MS } from '../../../services/photo-manager-service/photo-manager-service';
import welcomeTemplate from './welcome.tpl.html';
import './welcome.less';
import { resetAssessmentComponentModule } from '../../../components/reset-assessment-dialog/reset-assessment-dialog';
import { uiRouterStateModule } from '../../../../../shared/app/vendor/ui-router-module';
import { languages } from '../../../../../shared/app/constants/languages';
import { dialogComponentModule } from '../../../../../shared/app/components/dialog/dialog';
import { webcamStartComponentModule } from '../../../components/webcam-start/webcam-start';
import { challengeItemModelModule } from '../../../../../shared/app/models/challenge-item';
import { trackerServiceModule } from '../../../../../shared/app/services/tracker-service/tracker-service';
import { roundToMinutes } from '../../../../../shared/app/utils/date-utils';
import { codemirrorWorkspaceServiceModule } from '../../../../../shared/app/services/codemirror-workspace-service/codemirror-workspace-service';
const findPhotoManagerErrorMessage = (err) => {
  if (err.statusText || err.message) {
    return err.statusText || err.message;
  } else if (err) {
    return err;
  }
  return 'Unknown Photo Manager error';
};
export const welcomeRouteModule = angular
  .module('Q.routes.assessments.welcome', [
    uiRouterStateModule,
    durationFormatFilterModule,
    invitationsServiceModule,
    accountServiceModule,
    registerAccountComponentModule,
    legalLinksComponentModule,
    resetAssessmentComponentModule,
    dialogComponentModule,
    trackerServiceModule,
    durationFormatFilterModule,
    webcamStartComponentModule,
    challengeItemModelModule,
    codemirrorWorkspaceServiceModule,
  ])
  .component('welcomeHeader', {
    bindings: {
      greeting: '@',
      userInfo: '<',
    },
    template: `\
<h3>
{{$ctrl.greeting || 'Hello'}}{{ $ctrl.userInfo.welcomeName }}!
<button ng-if="$ctrl.userInfo.welcomeName" ng-click="$ctrl.userInfo.edit()" class="btn-default btn-sm btn-hover-only edit" tooltip="Edit Your Profile"></button>
</h3>`,
  })

  .config(function ($stateProvider) {
    let didShowReset = false;

    $stateProvider.state('assessments.welcome', {
      url: '?activate&email&firstName&lastName&autoRegister&practice',
      template: welcomeTemplate,
      data: {
        bodyClass: 'assessments welcome',
        label: 'Assessment Welcome',
      },
      controller: function welcomeController(
        $scope,
        $rootScope,
        invitationsService,
        process,
        assessmentResultAuth,
        assessment,
        accountService,
        $state,
        $stateParams,
        resetAssessmentDialog,
        $timeout,
        config,
        dialogService,
        $window,
        tracker,
        durationFormatFilter,
        photoManager,
        proctoringSatisfied,
        $log,
        appAlert,
        $modal,
        codemirrorWorkspaceService,
      ) {
        process.whenAssessmentResultReady().then(() => {
          if (
            !process.invitationIssue &&
            (process.isFinished() || process.embedOptions.hideWelcome)
          ) {
            process.next();
          }
        });
        $scope.process = process;

        if (process.liveInterview.setActiveChallengeId) {
          process.liveInterview.setActiveChallengeId(null);
        }

        $scope.activateToken = $stateParams.activate;
        $scope.activateMode = !!$scope.activateToken;

        const hasEnoughCredit =
          assessment.team.usageAllowed() || process.isTeamMember();
        const result = process.assessmentResult;
        const beganAssessment =
          ['started', 'submitted'].indexOf(result && result.state) !== -1;
        $scope.hasCredits = hasEnoughCredit || beganAssessment;

        const user = ($scope.user = assessmentResultAuth.candidate || {
          email: $stateParams.email,
        });

        $scope.assessmentPublished =
          process.isTeamMember() || assessment.isPublished();

        const account = accountService.get();

        // determine which languages are available on code challenges (ignoring quizzes)
        const languageCounts = {};
        const codeChallengeItems = process.challengeItems.filter(
          (ci) => ci && ci.challenge && ci.challenge.isCode(),
        );
        $scope.langsFull = [];
        $scope.langsPartial = [];
        codeChallengeItems.forEach((ci) => {
          const langs = ci.availableLanguages();
          langs.forEach((l) => {
            languageCounts[l.id] = (languageCounts[l.id] || 0) + 1;
          });
        });
        angular.forEach(languageCounts, (count, lang) => {
          $scope[
            count === codeChallengeItems.length ? 'langsFull' : 'langsPartial'
          ].push(languages[lang]);
        });
        $scope.langsFull.sort(languages.primaryCompare);
        $scope.langsPartial.sort(languages.primaryCompare);

        $scope.practiceParams = {
          assessmentId: assessment.practiceSlug || 'practice',
          email: user.email,
          returnTo: $state.href('.', {
            email: null,
            practice: null,
            firstName: null,
            lastName: null,
          }),
          // clear out unwanted params
          firstName: null,
          lastName: null,
          practice: null,
        };

        // Detect voice-to-text questions after loading full challenge data
        function checkForVoiceToTextQuestions() {
          $log.info('Challenge items:', process.challengeItems);

          // Load all challenges with their questions
          const promises = process.challengeItems.map((ci) =>
            ci.getChallenge(),
          );

          Promise.all(promises)
            .then((challenges) => {
              $log.info('Challenges loaded:', challenges);

              $scope.hasVoiceToTextQuestions = challenges.some(
                (challenge) => challenge && challenge.hasVoiceToTextQuestions,
              );

              $log.info(
                'Has voice to text questions:',
                $scope.hasVoiceToTextQuestions,
              );
              $scope.$apply(); // Need to apply since we're using native Promise
            })
            .catch((err) => {
              $log.error('Error loading challenges:', err);
            });
        }

        // Initial check for voice-to-text questions
        checkForVoiceToTextQuestions();

        // Check if browser is Chrome-based
        $scope.isChromeBased =
          /Chrome/.test(navigator.userAgent) &&
          /Google Inc/.test(navigator.vendor);

        // Function to test microphone
        $scope.testMicrophone = async function () {
          try {
            const stream = await navigator.mediaDevices.getUserMedia({
              audio: true,
            });
            $scope.microphoneWorks = true;
            stream.getTracks().forEach((track) => track.stop());
            $scope.$apply();
          } catch (err) {
            $scope.microphoneWorks = false;
            $scope.microphoneError = err.message;
            $scope.$apply();
          }
        };

        // Reset microphone test
        $scope.resetMicrophoneTest = function () {
          $scope.microphoneWorks = null;
          $scope.microphoneError = null;
        };

        // Check if assessment can be started
        $scope.canStartAssessment = function () {
          if (!$scope.hasVoiceToTextQuestions) return true;
          return $scope.microphoneWorks;
        };

        $scope.proctoringSatisfied = proctoringSatisfied;
        $scope.photoManager = photoManager;

        $scope.photoManagerError = null;
        // This fires the moment the camera goes live now, so it has to wait out the warm-up
        // itself: the welcome photo is the identification photo, and frame one is dark.
        $scope.handlePhotoManagerStart = () => {
          $timeout(() => {
            if (!photoManager.running()) {
              return;
            }
            photoManager.takeAssessmentPhotos();

            photoManager.takeWelcomePhoto().then(() => {
              if (!photoManager.running()) {
                return;
              }

              appAlert.clear();
              appAlert.success('Webcam ready');
              // Only once uploads work: the welcome retry would otherwise alert once a second.
              photoManager.setErrorHandler(
                $scope.handlePhotoManagerAssessmentError,
              );
            });
          }, CAMERA_WARMUP_MS);
        };
        $scope.handlePhotoManagerAssessmentError = (err) => {
          $scope.handlePhotoManagerError(err);
          const { state } = process.getCurrentStage();

          if (state === 'assessments.welcome') {
            return;
          }

          $modal.openOnce('webcamRestartDialog', {
            template: webcamRestartTemplate,
            controller: 'WebcamRestartCtrl as $ctrl',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              photoManager: () => $scope.photoManager,
            },
          });
        };
        $scope.handlePhotoManagerError = (err) => {
          const msg = findPhotoManagerErrorMessage(err);

          if (typeof msg === 'string') {
            const errorMessage =
              msg === 'Internal Server Error'
                ? 'If you have an ad blocker, try turning it off to show WebCam Feed'
                : msg;
            appAlert.error(`Webcam error: ${errorMessage}`);

            $log.error(`Webcam error: ${msg}`);
          } else {
            $log.error('Webcam error', msg);
            appAlert.error('Webcam error: unknown error');
          }
        };
        /**
         * Method to resume or start the assessment and handle the photo manager
         *
         * @param {boolean} isStart It is true if the assessment is being executed for the first time
         * @param isStart
         */
        $scope.resumeAssessment = (isStart) => {
          // Pre-warm LSP pods for all code challenges so they're ready when the candidate opens them.
          const seenPresets = new Set();
          (process.challengeItems || []).forEach((ci) => {
            const challenge = ci && ci.challenge;
            const rc = challenge && challenge.runConfig;
            if (!rc || !rc.languageServers || !rc.languageServers.length)
              return;
            const preset = [
              rc.language,
              rc.languageVersion,
              rc.preset || 'default',
            ].join('/');
            if (seenPresets.has(preset)) return;
            seenPresets.add(preset);

            // Build initial files so the LSP prewarm has real code to index from the start.
            // CCC: use challenge.files (multi-file workspace).
            // Classic: use setup field (the candidate's starting template).
            let initialFiles = [];
            try {
              if (challenge.files && challenge.files.length) {
                initialFiles = challenge.files
                  .filter((f) => f && f.contents && !f.hidden && !f.reference)
                  .map((f) => ({ path: f.path, contents: f.contents }));
              } else {
                const langObj = languages.getLang(rc.language);
                const ext = (langObj && langObj.ext && langObj.ext[0]) || 'txt';
                const lang = challenge.$currentLanguage;
                const body = lang && (lang.setup || lang.solution);
                if (body)
                  initialFiles = [{ path: 'solution.' + ext, contents: body }];
              }
            } catch (e) {
              // non-critical — falls back to v2 prewarm (no file content)
            }

            codemirrorWorkspaceService.preWarmProxy({
              preset,
              teamId: challenge.teamId,
              initialFiles,
            });
          });

          if (isStart) {
            process.startAssessmentResult().then(process.next);
          } else {
            process.next();
          }
        };

        $scope.userInfo = {
          edit: process.editProfile,
          get hasSolutions() {
            return (
              process.assessmentResult &&
              !!process.assessmentResult.validSolutions().length
            );
          },
          get needsRegistration() {
            return (
              !!process.auth.registrationRequired ||
              !!process.auth.emailVerificationRequired
            );
          },
          get accessRestricted() {
            return this.accessPending || this.accessClosed || this.accessLocked;
          },
          get accessLocked() {
            return !this.needsRegistration && process.wasAccessLocked;
          },
          get accessPending() {
            return (
              !this.needsRegistration &&
              process.assessmentResult &&
              process.assessmentResult.accessStartsAt &&
              new Date(process.assessmentResult.accessStartsAt) > new Date()
            );
          },
          get accessClosed() {
            return (
              !this.needsRegistration &&
              process.assessmentResult &&
              !process.assessmentResult.isSubmitted() &&
              process.assessmentResult.accessEndsAt &&
              new Date(process.assessmentResult.accessEndsAt) < new Date()
            );
          },
          // True if the process has not started yet but the candidate is logged in and ready and has not yet completed any work on this assessment result
          get readyForCleanStart() {
            return (
              !this.needsRegistration &&
              !process.started &&
              process.assessmentResult &&
              !this.hasSolutions &&
              !this.accessRestricted
            );
          },
          // True if the process has not started yet but the candidate is logged in and ready and has previously started work on this assessment result
          get readyForContinuedStart() {
            return (
              !this.needsRegistration &&
              !process.started &&
              process.assessmentResult &&
              this.hasSolutions &&
              !this.accessRestricted
            );
          },
          get currentlyTakingAssessment() {
            return (
              !this.needsRegistration &&
              process.started &&
              !this.accessRestricted
            );
          },
          get willBeReminded() {
            return (
              process.auth.invitation &&
              process.auth.invitation.reminderAt &&
              new Date(process.auth.invitation.reminderAt) > new Date()
            );
          },
          get welcomeName() {
            if (
              process.assessmentResult &&
              process.assessmentResult.teamCandidate &&
              process.assessmentResult.teamCandidate.forgotten
            ) {
              return '';
            }

            const name = process.auth.candidate && process.auth.candidate.name;
            return name ? `, ${name}` : '';
          },
        };

        if (!account.verified) {
          // make sure we're listening to external logins, even if they aren't logged in yet
          accountService.accountChangeListener.enable();
          $scope.$on('app.accountSetRemotely', () => {
            $state.reload();
          });
        } else if (
          !didShowReset &&
          process.assessmentResult &&
          process.isTeamMember() &&
          !process.assessmentResult.isSnapshotCurrent()
        ) {
          if (process.assessmentResult.solutions.length) {
            didShowReset = true;
            // show the reset dialog for team members who arrive with an outdated result
            resetAssessmentDialog.open(process, true);
          } else {
            // always reset an assessment that wasn't actually started yet
            process.reset(true);
          }
        }

        process.postUpdated(null, {
          id: 'welcome',
          title: 'Welcome',
          index: 0,
        });

        const _goToPractice = () => {
          if (!$scope.userInfo.needsRegistration) {
            $scope.redirectingToPractice = true;
            $timeout(() => {
              $state.go('assessments.welcome', $scope.practiceParams);
            });
          }
        };
        if ($stateParams.practice && !assessment.isPractice) {
          if ($scope.userInfo.needsRegistration) {
            $scope.$watch(
              () => $scope.userInfo.needsRegistration,
              _goToPractice,
            );
          } else {
            _goToPractice();
          }
        }

        if (process.significantTimeDelay) {
          const diffMin = durationFormatFilter(
            roundToMinutes(Math.abs(config.timeDiffMS)),
          );
          tracker.trackError('Significant Time Delay', {
            delayMS: config.timeDiffMS,
            diffMin,
          });
          dialogService
            .open(
              `\
<p>We've detected a significant difference between the local time on this machine and our servers of
<strong>${diffMin}</strong>.</p>
<p>This can prevent you from having the fully allotted time to complete your challenges.</p>
<p>Please correct this issue and reload this page before continuing.</p>`,
              'Significant Time Difference Detected',
              [
                { id: 'yes', text: 'Reload' },
                {
                  id: 'no',
                  style: 'link',
                  text: 'Continue Anyway',
                  confirmMessage: `You may have trouble completing the ${assessment.nounLower}. Are you sure?`,
                },
              ],
              {
                windowClass: `no-close-button significant-time-delay-dialog`,
                backdrop: 'static',
                keyboard: false,
              },
            )
            .then(({ id }) => {
              if (id === 'no') {
                config.ignoreTimeDelay();
              } else {
                $window.location.reload(true);
              }
            });
        }
      },
    });
  });
